import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudVolumeSnapshot = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume_snapshot/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllVolumeSnapshot = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_volume_snapshot_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudVolumeSnapshot = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume_snapshot/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudVolumeSnapshot = (data, id) => {
  let url = privateCloudBaseUrl + 'volume_snapshot/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    needPrivateCloudProjectHeader: true,
    url: url,
    data: data,
    method: method
  })
}

export const deletePrivateCloudVolumeSnapshot = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume_snapshot/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
